export const SlackPluginClientID = '158926675253.8397744408117';
export const GA_ID = 'G-CBV441CZQB';
